/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
'use client'

import './ProductImageGalleryStyles.css'

import { type LoadableComponentProps, Media } from '../../types'
import DesktopGallery from './DesktopGallery'
import MobileGallery from './MobileGallery'

export type ProductImageGalleryProps = {
  galleryItems?:
    | {
        media?: Media
        tag?: {
          text: string
          icon?: string | null
        }
      }[]
    | null
}

export default function ProductImageGallery(
  props: LoadableComponentProps<ProductImageGalleryProps>,
) {
  return (
    <>
      <DesktopGallery {...props} />

      <MobileGallery {...props} />
    </>
  )
}
